<template>
  <wiskModal :visible="!!editAction" @hide="setGlobalAction({ type: 'adjustmentTypeEdit', action: null })" :title="modalTitle" :hideFooter="!!(adjustmentType && adjustmentType.id)" preventOKClose
    :okText="translations.txtGenericSave" @ok="save" size="md" :okDisabled="!valid" :warning="!!(adjustmentType && adjustmentType.archived)">
    <template v-slot:modal-header-extra>
      <wiskActions :title="translations.txtGenericActions" :actions="pageActions" v-if="adjustmentType && adjustmentType.id" />
    </template>

    <wiskInputGroup @errorCountChanged="setValidState" v-if="adjustmentType" @operationsChange="operations = $event" :key="key" style="min-height: 300px;" horizontal>
      <b-row>
        <b-col>
          <wiskInput :label="translations.txtAdjustmentTypeLabel" required autofocus
            operation="label" :modelValue="adjustmentType.label" @operation="onChange" triggerInputOnSet />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <wiskSelect :label="translations.txtAdjustmentTypeKind" required
            operation="kind" :modelValue="adjustmentType.kind" @operation="onChange"
            :items="kindOptions" trackBy="id" fixedWrapper />
        </b-col>
        <b-col>
          <wiskSelect :label="translations.txtAdjustmentTypeBasis" required
            operation="basis" :modelValue="adjustmentType.basis" @operation="onChange"
            :items="basisOptions" trackBy="id" fixedWrapper />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <wiskInput :label="translations.txtAdjustmentTypeDefaultRate" inputType="number" :decimals="4" decimalsAsNeeded
            operation="default_rate" :modelValue="adjustmentType.default_rate" @operation="onChange" />
        </b-col>
        <b-col>
          <wiskInput :label="translations.txtAdjustmentTypeCapitalizeIntoCost" inputType="checkbox"
            operation="capitalize_into_cost" :modelValue="adjustmentType.capitalize_into_cost"
            @update:modelValue="val => adjustmentType.capitalize_into_cost = val" @operation="onChange" />
        </b-col>
      </b-row>
    </wiskInputGroup>

    <wiskLoading :loading="loading" />
  </wiskModal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import api from '@/api'

const newAdjustmentType = {
  id: 0,
  label: '',
  kind: null,
  basis: null,
  default_rate: 0,
  capitalize_into_cost: false,
  archived: false
}

export default {
  name: 'AdjustmentTypeEdit',
  components: {},
  props: { editAction: Object },
  data() {
    return {
      loading: false,
      adjustmentType: null,
      operations: [],
      key: 1,
      valid: true
    }
  },
  computed: {
    ...mapState(['translations', 'adjustmentTypesById']),
    kindOptions() {
      return [
        { id: 'fee', title: this.translations.txtAdjustmentTypeKindFee },
        { id: 'tax', title: this.translations.txtAdjustmentTypeKindTax },
        { id: 'deposit', title: this.translations.txtAdjustmentTypeKindDeposit }
      ]
    },
    basisOptions() {
      return [
        { id: 'flat', title: this.translations.txtAdjustmentTypeBasisFlat },
        { id: 'per_unit', title: this.translations.txtAdjustmentTypeBasisPerUnit },
        { id: 'per_case', title: this.translations.txtAdjustmentTypeBasisPerCase },
        { id: 'percent_of_line', title: this.translations.txtAdjustmentTypeBasisPercentOfLine }
      ]
    },
    pageActions() {
      if (this.adjustmentType) {
        return [
          { key: 1, title: this.translations.txtGenericArchive, icon: 'wisk-archive', variant: 'danger', hide: this.adjustmentType.archived, action: this.archive },
          { key: 2, title: this.translations.txtGenericRestore, icon: 'wisk-history', variant: 'success', hide: !this.adjustmentType.archived, action: this.restore }
        ]
      }
      return []
    },
    modalTitle() {
      if (this.adjustmentType) {
        let archived = this.adjustmentType.archived ? ` - (${this.translations.txtGenericArchived})` : ''
        return this.adjustmentType.id
          ? this.translations.txtAdjustmentTypeEdit + ': ' + this.adjustmentType.label + archived
          : this.translations.txtAdjustmentTypeNew
      }
      return ''
    }
  },
  methods: {
    ...mapActions(['setGlobalAction']),
    setValidState(errorCount) {
      this.valid = !errorCount
    },
    save(operations = this.operations) {
      let ops = Array.isArray(operations) ? [...operations] : [operations]

      // always include it for new types
      if (!this.adjustmentType.id && !ops.some(op => op.type === 'capitalize_into_cost')) {
        ops.push({ type: 'capitalize_into_cost', value: this.adjustmentType.capitalize_into_cost })
      }

      this.loading = true

      api.updateAdjustmentType(this.adjustmentType.id, ops).then(updated => {
        if (!this.adjustmentType.id && updated && updated.id) {
          this.setGlobalAction({ type: 'adjustmentTypeEdit', action: null })
        }

        if (typeof this.editAction.onChange === 'function') {
          this.editAction.onChange(updated)
        }

        this.$store.commit('mutateAdjustmentType', updated)
        this.adjustmentType = { ...updated }
      }).finally(() => {
        this.loading = false
      })
    },
    onChange(operation) {
      if (this.adjustmentType && this.adjustmentType.id) {
        this.save(operation)
      }
    },
    archive() {
      this.save([{ type: 'archive', value: true }])
    },
    restore() {
      this.save([{ type: 'archive', value: false }])
    }
  },
  watch: {
    editAction: {
      immediate: true,
      handler(editAction) {
        if (editAction) {
          if (editAction.id === 0) {
            this.adjustmentType = { ...newAdjustmentType }
          }

          if (editAction.id) {
            this.adjustmentType = { ...this.adjustmentTypesById[editAction.id] }
          }

          if (editAction.adjustmentType) {
            this.adjustmentType = { ...editAction.adjustmentType }
          }
        }
      }
    }
  }
}
</script>

<style lang="scss"></style>
